import type { DataTableNumberOperator } from '@/components/molecules';
import {
  CreditMemoStatus,
  CreditMemoType,
  type CreditMemoStatus as CreditMemoStatusValue,
  type CreditMemoType as CreditMemoTypeValue,
} from '@/lib/api/types/billing';
import { formatCreditMemoLabel } from './credit-memo-formatters';

export type CreditMemoTypeFilter = CreditMemoTypeValue | 'all';
export type CreditMemoStatusFilter = CreditMemoStatusValue | 'all';

export interface CreditMemoListFilters {
  q: string;
  type: CreditMemoTypeFilter;
  status: CreditMemoStatusFilter;
  creditMemoNumber: string;
  invoiceId: string;
  totalOp: DataTableNumberOperator;
  totalValue: string;
  remainingOp: DataTableNumberOperator;
  remainingValue: string;
  sort: number;
  page: number;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  contactId: string | undefined;
}

export const DEFAULT_CREDIT_MEMO_LIST_FILTERS: CreditMemoListFilters = {
  q: '',
  type: 'all',
  status: 'all',
  creditMemoNumber: '',
  invoiceId: '',
  totalOp: 'eq',
  totalValue: '',
  remainingOp: 'eq',
  remainingValue: '',
  sort: 0,
  page: 1,
  dateFrom: undefined,
  dateTo: undefined,
  contactId: undefined,
};

export const CREDIT_MEMO_TYPE_FILTERS: { value: CreditMemoTypeFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  ...Object.values(CreditMemoType).map((value) => ({
    value,
    label: formatCreditMemoLabel(value),
  })),
];

export const CREDIT_MEMO_STATUS_FILTERS: { value: CreditMemoStatusFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  ...Object.values(CreditMemoStatus).map((value) => ({
    value,
    label: formatCreditMemoLabel(value),
  })),
];
